import styled from "styled-components";
import servicebackground from "../assets/aboutbackground.jpeg";
import realizationThree from '../assets/2022/photos/accueil/nouveau/realization-3.jpeg'
import backgroundHeader from '../assets/2022/photos/accueil/nouveau/IMG_2859.JPG'

const firstStyleOption = styled.div`

.top{
  margin-top: 3em;
}

.content{
 padding: 1em 0;

 p,span{
  margin: 1.5em 0;
  font-weight: 300;
  line-height: 27px;
  font-size: 17px;
  color: #3D4851;
 }
}


#about-lift{
 background: transparent;
 position: relative;
 top: -5em;

 h2,
    h4 {
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      font-size: 29px;
      text-align: center;
      color: white;
      font-weight: 600;
      margin-top: 0.8em;
      margin-bottom: 0.8em;
    }

    h4 {
      font-size: 20px;
      color: #009444;
    }

    p {
      font-style: normal;
      font-weight: normal;
      font-weight: 300;
      line-height: 27px;
      font-size: 15px;
      text-align: center;
      color: white;
      margin-bottom: 3em;
    }
}

.cards {
 width: 100%;
 float:left;
 .inner {
   min-height: 200px;

   @media(min-width: 1023px){
     width: 95%;
   }
   width: 100%;

   &.full{
     width: 100%;
   }
 }

 .inner {
   background: #ffffff;
   box-shadow: 0px 4px 25px rgba(61, 72, 81, 0.05);
   border-radius: 4px;
   padding: 1em 1em 1.5em;

   .xs-9 {
     padding: 0 0.5em;
   }
 }
}
.card {
 h4{
   font-size: 19px !important;
 }
 h4,
 p {
   text-align: left !important;
 }

 p {
   margin-bottom: 0 !important;
   font-size: 15px !important;
   color: #3d4851 !important;
 }
 img {
   height: 80px !important;
   width: 100% !important;
   object-fit: contain !important;
   margin: 1.5em 0;
 }
}

  .image{
   width: 100%;
   object-fit: cover;
  }

  #post-title{
   margin-top: 1em ;
  }

  .withBackground {
    position: relative;
    background: url(${servicebackground});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 300px;

    h3{
       position: relative:
       z-index:1 ;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 1px;
      font-size: 32px;
      color: #FFFFFF;
    }

    &::before {
      content: "";
      position: absolute;
      background: rgba(0, 148, 68, 0.25);

      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      height: 100%;
      width: 100%;
    }
  }
  a {
    padding: 1em;
    width: 100%;
    display: inline-block;
    &.active {
      color: #009444;
    }
    color: #8795a1;
    text-decoration: none;
  }


  .pre{
   h2{
    font-weight: 600;
    line-height: normal;
    font-size: 32px;
    text-align: center;
    color: #222829;
    margin-top: 20px;
   }
   h4{
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 24px;
    text-align: center;
    color: #009444;
    margin-top: 20px;
   }
  }

 .info-card{
  margin: .6em 0;
 height: auto;

  .inner{
   background: #FFFFFF;
   box-shadow: 0px 4px 25px rgba(61, 72, 81, 0.05);
   border-radius: 4px;
   height: 420px;
   width: 95%;
  }

 img{
  width: 100%;
  height: 250px;
  object-fit: cover;
  object-position: center;
 }

 h4{
  padding: 15px 30px 10px;
 }

 p{
 padding: 0px 30px 45px;
 }

 h4{
  font-weight: 600;
  line-height: 33px;
  font-size: 22px;
  color: #009444;
 }

 p{
  font-weight: 300;
  line-height: 24px;
  font-size: 18px
  color: #3D4851;
 }

  }
`;

const secondStyleOption = styled.div`


#overlay-modal{

  padding: 2em;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1001;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,0.9);
  text-align: center;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;

  img{
    height: 70%;
    width: 90%;
    object-fit: contain;
    object-position: center;
  }

  button{
    border: 2px solid white;
    color: white;
    font-weight: 200;
    font-size: 18px;
    padding: 0.5em 1em;
    background: transparent;
    border-radius: 5px;
    position: absolute;
    right: 4.7em;
    top: 4.7em;
  }

}

  .body{
    display: flex;
    flex-direction: column;
  }

  .header{
    background-image: url(${backgroundHeader});
    background-size: cover;
    background-position: 0% 25%;
    position: relative;
    z-index: 0;
    height: 400px;
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    align-items: flex-start;
    justify-content: center;
    padding: 0 1.75em;

    &::before{
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;
      background: rgba(0,0,0,0.275);
      z-index: -1;
    }

    @media(min-width: 2000px){
      background-position: 0 -20em;
    }

    h3{
      margin: 0;
      font-weight: 1000;
      font-size: 26px;
      text-transform: uppercase;
      text-align: left;
      font-style: italic;
    }

    p{

      font-weight: 600;
      font-size: 3em;
      @media(max-width: 1024px){
      font-size: 2em;
      }
    }

    h3,p{
      color: white;
    }

  }

  .image-tabs{
    padding: 3em 24px;

    a{
        text-decoration: none;
    }

  }


  .text-after-header{

    padding: 50px 15px 0px;
    margin: auto;

    h3{
      margin: 0;
      font-size: 30px;
      font-weight: 600;
      color: #009444;
      text-align: left;
      font-family: Poppins;
      line-height: 45px;
      padding: 0px 1em 0px 0;
    }

    p{
      text-align: left;
      font-family: Poppins;
      color: #000;
      font-size: 18px;
      line-height: 30px;
      margin-top: 0;
      margin-bottom: 10px;
      letter-spacing: 1px;
      font-weight: 400;
      padding: 0px 1.2em 0px 0;
    }

    img{
      margin-right: 0;
      padding-top: 75px;
      padding-bottom: 75px;
      object-fit: cover;
      object-position: center;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 120px;
      padding-bottom: 120px;
      border-radius: 20px;
      margin-right: 25px;
      background-size: cover;
      background-position: center center;
      height: 350px;
      width: 100%;
    }

  }



  @media(max-width: 768px){
    .text-after-header{
      h3{
        margin: 0;
        font-size: 22px;
        font-weight: 600;
        color: #009444;
        text-align: left;
        font-family: Poppins;
        line-height: 33px;
        padding: 0px 0.25em 25px 0;
      }
      p{

      }
    }
  }



  .images-after-header{
    margin: auto;
    padding: 1.5em 0em 3em;
    text-align: center;

    a{
        display: inline-block;
        min-height: 300px;
        position: relative;
        text-decoration: none;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 10px;
        overflow: hidden;

      img{
        width: 100%;
        height: 100%;
        position: absolute;
        padding: 1em;
        border-radius: 10px;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        overflow: hidden;
        border-radius: 35px;
        object-fit: cover;
        object-position: center;
      }

      @media(max-width: 768px){
        img{
          object-position: top;
        }
      }

      h3, p{
        position: relative;
        z-index: 1;
        bottom: 0;
        left: 0;
        text-align: center;
        padding: 2em;
        color: white;
        font-weight: 500;
        font-size: 33px;
      }

      p{
        font-size: 18px;
      }

    }
  }

  .founder-bar{

    background-image: none;
    background-size: cover;
    background-position: center center;
    padding: 50px 15px;
    opacity: 1;
    background-color: #009444;
    display: flex;

    h2{
      font-size: 23px;
      text-transform: uppercase;
      text-align: left;
      font-style: italic;
      font-weight: 800;
      color: white;
    }

    h4{
      font-family: Poppins;
      font-weight: 500;
      color: #fff;
      font-size: 40px;
      text-align: left;
    }

    p{
      font-size: 19px;
      margin-top: 0;
      text-align: left;
      color: #fff;
      font-family: Poppins;
      line-height: 30px;
      letter-spacing: 1px;
      font-weight: 500;
      margin-top: 1em;
    }

    img{
      border: 4px solid #adbc19;
      height: 100px;
      width: 100px;
    }

    .founder-image {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      img{
        border: 4px solid #adbc19;
        height: 80px;
        width: 80px;
        border-radius: 50px;
        margin-top: 1em;
        display: inline-block;
      }

      p{
        font-size: 19px;
        margin-top: 0;
        text-align: left;
        color: #fff;
        font-family: Poppins;
        line-height: 30px;
        letter-spacing: 1px;
        display: inline-block;
        padding: 0em 0.75em;
        position: relative;
        top: 8px;
      }

    }

  }


  .solutions{

    padding: 3em 1em;
    margin: auto;
    text-align: center;

    h2{
      margin: 0;
      font-size: 30px;
      font-weight: 600;
      color: #009444;
      text-align: left;
      font-family: Poppins;
      line-height: 45px;
      padding: 0px 1.2em 50px 0;
    }

    p{
      text-align: left;
      font-family: Poppins;
      color: #000;
      font-size: 18px;
      line-height: 30px;
      margin-top: 0;
      margin-bottom: 10px;
      letter-spacing: 1px;
      font-weight: 400;
      padding-right: 1em;
    }

  }


  .impact{

    padding: 3em 1.75em;

      .inner{
          padding: 3em 24px;
      }

      h3{
        margin: 0;
        font-size: 30px;
        font-weight: 600;
        color: #009444;
        text-align: left;
        font-family: Poppins;
        line-height: 45px;
        padding: 0px 1.2em 50px 0;
      }

      p{
        text-align: center;
        font-family: Poppins;
        color: #000;
        font-size: 15px;
        line-height: 30px;
        margin-top: 0;
        margin-bottom: 10px;
        letter-spacing: 0.5px;
        font-weight: 500;
      }

      #other-paragraph{
        text-align: left;
        font-family: Poppins;
        color: #000;
        font-size: 19px;
        line-height: 30px;
        margin-top: 0;
        margin-bottom: 10px;
        letter-spacing: 1px;
        font-weight: 400;
      }

      img{
        height: 200px;
        width: 300px;
        padding: 1em;
        object-fit: contain;
        object-position: center;
      }

      .box{
        padding: 1em 0;
        line-height: 30px;
        text-align: center;

        span{
          font-weight: 700;
        }
      }
  }


  .after-solutions, .mid-header{

    padding: 2em 0;
    width: 93%;
    margin: auto;
    position: relative;
    height: 45em;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    &::before{
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;
      background: rgba(0,0,0,0.275);
      z-index: 1;
    }

    img{
      width: 100%;
      object-fit: cover;
      object-position: center;
      position: absolute;
      left: 0;
      right: 0;
      height: 100%;
      padding: 0px 2em;
      top: 0;
      bottom: 0;
      padding: 0;
    }

    h3,p {
      color: white;
      position: relative;
      z-index: 1;
      padding-left: 20px;
      padding-right: 20px;
      bottom: 0;
    }

    h3{
      font-family: Poppins;
      font-weight: 600;
      color: #fff;
      font-size: 30px;
      text-align: left;
      padding-bottom: 20px;
    }

    p{
      font-family: Poppins;
      color: #fff;
      font-size: 19px;
      line-height: 30px;
      margin-top: 0;
      letter-spacing: 1px;
      font-weight: 400;
    }

    @media(max-width: 768px){
      h3{ font-size: 24px !important; }
      p{ font-size: 15px !important; }

    }

  }


#coffee{

  height: auto;

  .coffee-h{
    background-image: url(${realizationThree});
    background-size: cover;
    background-position: center;
    height: 400px;
    flex: 1;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  h2{
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 3em;
    color: #FFFFFF;
  }

  p{
    font-family: Poppins;
    color: #fff;
    font-size: 19px;
    line-height: 30px;
    margin-top: 0;
    margin-bottom: 35px;
    letter-spacing: 1px;
    font-weight: 400;
  }

  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  #nous{
    background-color: #009444;
    color: #fff;
    font-family: Poppins;
    border-radius: 20px;
    text-transform: uppercase;
    padding: 5px 30px;
    font-weight: 500;
    margin-right: 1em auto;
    border: 3px solid #009444;
    font-size: 18px;
    letter-spacing: 0.65px;
    text-decoration: none;
  }

}


#just-more-logos {

  padding: 1em 1em;
  margin: 4em auto 0;
  position: relative;
  display: flex;
  min-height: 100px;
  flex-direction: column;

  *{
    font-family: Poppins;
  }

  p#distinctions-paragraph{
    text-align: left;
    font-family: Poppins;
    color: #000;
    font-size: 19px;
    line-height: 30px;
    margin-top: 0;
    margin-bottom: 10px;
    letter-spacing: 1px;
    font-weight: 400;
  }

  h4 {
    margin: 0;
      font-size: 30px;
      font-weight: 600;
      color: #009444;
      text-align: left;
      font-family: Poppins;
      line-height: 30px;
      padding: 0px 1.2em 50px 0;
  }

  img {
    background: #ffffff;
    border-radius: 4px;
    object-fit: contain;
    height: 100px;
    margin: 1.5em 0;
  }

  p.image-caption{
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    padding: 0 10% 0 10%;
    color: #3D4851;
    text-align: left;
    margin: 3em 0;
  }

}
}


.sdgs{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 1em;

    img{
      height: 190px;
      width: 170px;
      padding: 20px;
    }

    h1{
      font-size: 33px;
      font-weight: 600;
      color: #009444;
    }

}

@media(max-width: 768px){

  .founder-bar h4{
      font-size: 25px;
      line-height: 32px;
  }

  .header{
      padding: 0;
      height: 250px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
  }

  p, li, span{
    font-size: 14.5px !important;
    line-height: 30px !important;
  }

  .header h3, .header p{
    margin-left: 1em !important;
  }

  .header h3{
    font-size: 21px;
  }

  .header p{
    font-size: 1.25em !important;
    line-height: 1.7em !important;
    letter-spacing: 0.75px;
    font-weight: 600;
  }

  .impact{
    padding: 0em 1em !important;
    .inner{
      padding: 3em 0 !important;
    }
  }

  .impact img{
    height: 140px;
  }

  .impact p{
    text-align: center;
  }

  #just-more-logos {
    padding: 1em 2em;
  }

  .impact .box{
    text-align: center;

    img{
      width: auto;
    }
  }

  #coffee h2{
    font-size: 25px;
  }


  .solutions h2, #just-more-logos h4, .impact h3, .sdgs h1, {
    font-size: 30px;
    padding: 0px 0em 30px 0;
  }

}


#just-more-logos {

  padding: 1em 1em;
  margin: 4em auto 0;
  position: relative;
  display: flex;
  min-height: 100px;
  flex-direction: column;

  *{
    font-family: Poppins;
  }

  p#distinctions-paragraph{
    text-align: left;
    font-family: Poppins;
    color: #000;
    font-size: 19px;
    line-height: 30px;
    margin-top: 0;
    margin-bottom: 10px;
    letter-spacing: 1px;
    font-weight: 400;
  }

  h4 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #009444;
    text-align: left;
    font-family: Poppins;
    line-height: 30px;
    padding: 0px 1.25em 50px 0;
  }

  img {
    background: #ffffff;
    border-radius: 4px;
    object-fit: contain;
    height: 100px;
    margin: 1.5em 0;
  }

  .flex{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  p.image-caption{
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    padding: 0 5% 0 5%;
    color: #3D4851;
    text-align: left;
    margin: 3em 0;
  }

}

.in{
  width: 100%;
  margin: auto;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}

.solutions h2, .sdgs h1, #just-more-logos h4{
    font-size: 30px;
    padding: 0px 0.75em 25px 0;
    text-align: left;
}

.sdgs h1{
  font-size: 25px;
  padding: 0px 0.25em 20px 0;
  text-align: center;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.images-after-header a h3 {
  font-size: 23px;
  font-weight: 600;
  width: 100%;
}

.av{
  font-size: 30px;
  color: #009444;
  line-height: 45px;
}

`;

export default ( option ) => option === "first" ? firstStyleOption: secondStyleOption;



// WEBPACK FOOTER //
// /opt/build/repo/src/styles/about.style.js